import { Injectable } from '@angular/core';
import { URL_API } from '../global/config';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Postulante } from '../models/Postulante';
import { map } from 'rxjs/operators';
import { Postulantex } from '../models/Postulantex';

@Injectable({
  providedIn: 'root'
})
export class PostulanteApiRestService {

  private urlEndPoint: string = URL_API.UrlApi+'/api/v1/postulantes';
  private httpHeaders = new HttpHeaders({'Content-Type':'application/json'});

constructor(
  private http: HttpClient
) { }

  //traer a Todos
  getPostulantes(): Observable<Postulantex[]>{
    return this.http.get(this.urlEndPoint).pipe(
      map( (response) =>
        response as Postulantex[]
      )
    )
  }

  //traer por ID
  getPostulantePorId(id: Number): Observable<Postulantex>{
    return this.http.get<Postulantex>(`${this.urlEndPoint}/${id}`)
  }

  //crear Postulante
  crearPostulante(postulante: Postulantex): Observable<Postulantex>{
    return this.http.post<Postulantex>(this.urlEndPoint, postulante, {headers: this.httpHeaders});
  }

  //actualizar el Objeto Postlante
  actualizarPostulante(postulante: Postulantex): Observable<Postulantex>{
    return this.http.put<Postulantex>(`${this.urlEndPoint}/${postulante.id}`, postulante, { headers: this.httpHeaders});
  }

}
